import apiClient from '@utils/apiClient';

export const projectList = (payload) => {
  return apiClient.get(`${apiClient.Urls.projectList}`, payload, true);
};

export const locations = (payload) => {
  return apiClient.get(`${apiClient.Urls.locations}`, payload, true);
};

export const bbsList = (payload) => {
  return apiClient.get(`${apiClient.Urls.bbsList}`, payload, true);
};

export const fetchProject = (payload) => {
  return apiClient.post(`${apiClient.Urls.fetch}`, payload, true);
};

export const newProject = (payload, type) => {
  // Append the type to the URL
  
  const url = `${apiClient.Urls.newProject}?type=${type}`;
  
  return apiClient.post(url, payload, true);
};

// export const newProject = (params, payload) => {
//   const queryString = `type=${encodeURIComponent(params.type)}`;
  
//   // Send POST request with query string in URL and payload in the body
//   return apiClient.post(`${apiClient.Urls.newProject}?${queryString}`, payload, true);
// };


export const editProjectUser = (payload, id) => {
  if (!id) {
    throw new Error('ID is required for this API call');
  }
  return apiClient.post(`${apiClient.Urls.editProjectUser}/${id}`, payload, true);
};

export const editProject = (payload, id) => {
  if (!id) {
    throw new Error('ID is required for this API call');
  }
  return apiClient.post(`${apiClient.Urls.editProject}/${id}`, payload, true);
};


